'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _creditcard = require('./creditcard');

var _creditcard2 = _interopRequireDefault(_creditcard);

var _neteller = require('./neteller');

var _neteller2 = _interopRequireDefault(_neteller);

var _skrill = require('./skrill');

var _skrill2 = _interopRequireDefault(_skrill);

var _paypal = require('./paypal');

var _paypal2 = _interopRequireDefault(_paypal);

var _zimpler = require('./zimpler');

var _zimpler2 = _interopRequireDefault(_zimpler);

var _paysafecard = require('./paysafecard');

var _paysafecard2 = _interopRequireDefault(_paysafecard);

var _trustly = require('./trustly');

var _trustly2 = _interopRequireDefault(_trustly);

var _muchbetter = require('./muchbetter');

var _muchbetter2 = _interopRequireDefault(_muchbetter);

var _venuspoint = require('./venuspoint');

var _venuspoint2 = _interopRequireDefault(_venuspoint);

var _vega = require('./vega');

var _vega2 = _interopRequireDefault(_vega);

var _bank = require('./bank');

var _bank2 = _interopRequireDefault(_bank);

var _bankiban = require('./bankiban');

var _bankiban2 = _interopRequireDefault(_bankiban);

var _instadebit = require('./instadebit');

var _instadebit2 = _interopRequireDefault(_instadebit);

var _idebit = require('./idebit');

var _idebit2 = _interopRequireDefault(_idebit);

var _ideal = require('./ideal');

var _ideal2 = _interopRequireDefault(_ideal);

var _epro = require('./epro');

var _epro2 = _interopRequireDefault(_epro);

var _siru = require('./siru');

var _siru2 = _interopRequireDefault(_siru);

var _ppro = require('./ppro');

var _ppro2 = _interopRequireDefault(_ppro);

var _ecopayz = require('./ecopayz');

var _ecopayz2 = _interopRequireDefault(_ecopayz);

var _reversewithdrawal = require('./reversewithdrawal');

var _reversewithdrawal2 = _interopRequireDefault(_reversewithdrawal);

var _swish = require('./swish');

var _swish2 = _interopRequireDefault(_swish);

var _webredirect = require('./webredirect');

var _webredirect2 = _interopRequireDefault(_webredirect);

var _mobilepay = require('./mobilepay');

var _mobilepay2 = _interopRequireDefault(_mobilepay);

var _funanga = require('./funanga');

var _funanga2 = _interopRequireDefault(_funanga);

var _astropaycard = require('./astropaycard');

var _astropaycard2 = _interopRequireDefault(_astropaycard);

var _communitybank = require('./communitybank');

var _communitybank2 = _interopRequireDefault(_communitybank);

var _jeton = require('./jeton');

var _jeton2 = _interopRequireDefault(_jeton);

var _cryptocurrency = require('./cryptocurrency');

var _cryptocurrency2 = _interopRequireDefault(_cryptocurrency);

var _bestpay = require('./bestpay');

var _bestpay2 = _interopRequireDefault(_bestpay);

var _ezeewallet = require('./ezeewallet');

var _ezeewallet2 = _interopRequireDefault(_ezeewallet);

var _mifinity = require('./mifinity');

var _mifinity2 = _interopRequireDefault(_mifinity);

var _cashlib = require('./cashlib');

var _cashlib2 = _interopRequireDefault(_cashlib);

var _apco = require('./apco');

var _apco2 = _interopRequireDefault(_apco);

var _pradexx = require('./pradexx');

var _pradexx2 = _interopRequireDefault(_pradexx);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  creditcard: _creditcard2.default,
  neteller: _neteller2.default,
  skrill: _skrill2.default,
  venuspoint: _venuspoint2.default,
  vega: _vega2.default,
  paypal: _paypal2.default,
  zimpler: _zimpler2.default,
  paysafecard: _paysafecard2.default,
  muchbetter: _muchbetter2.default,
  trustly: _trustly2.default,
  bank: _bank2.default,
  instadebit: _instadebit2.default,
  idebit: _idebit2.default,
  ideal: _ideal2.default,
  epro: _epro2.default,
  siru: _siru2.default,
  ppro: _ppro2.default,
  ecopayz: _ecopayz2.default,
  reversewithdrawal: _reversewithdrawal2.default,
  swish: _swish2.default,
  bankiban: _bankiban2.default,
  mobilepay: _mobilepay2.default,
  funanga: _funanga2.default,
  webredirect: _webredirect2.default,
  astropaycard: _astropaycard2.default,
  communitybank: _communitybank2.default,
  jeton: _jeton2.default,
  cryptocurrency: _cryptocurrency2.default,
  bestpay: _bestpay2.default,
  ezeewallet: _ezeewallet2.default,
  mifinity: _mifinity2.default,
  cashlib: _cashlib2.default,
  apco: _apco2.default,
  pradexx: _pradexx2.default
};